module.exports = " <div class=mdl-card__title> <h4 class=mdl-card__title-text>{{'scheduled.details.label.title' | label}}</h4> </div> <div class=mdl-card__supporting-text> {{{'scheduled.details.text' | label}}} </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/client/segments/ScheduledDetails.vue
// module id = 339
// module chunks = 0